import {
  Required,
  IsString,
  IsNumber,
  DataValidator,
  transformKeys,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface SidebarFolderResponse {
  folder: {
    id: string;
    name: string;
    sort_order: number;
  };
}

// 嵌套对象类
class Folder {
  @Required("ID cannot be empty")
  @IsString("ID must be a string")
  id: string;

  @Required("Name cannot be empty")
  @IsString("Name must be a string")
  name: string;

  @Required("Sort order cannot be empty")
  @IsNumber("Sort order must be a number")
  sortOrder: number;
}

// 主数据类
export class SidebarFolderData {
  @Required("Folder cannot be empty")
  @ValidateNested(Folder)
  folder: Folder;
}

const transformAndValidateSidebarFolder = (
  response: SidebarFolderResponse
): SidebarFolderData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, SidebarFolderData);
  } catch (error) {
    console.error("Sidebar folder data validation failed:", error.message);
    throw error;
  }
};

// 新建文件夹
export const sidebarFolder = async (name: string, productId: string): Promise<SidebarFolderData> => {
  const res = await api.post<SidebarFolderResponse>("/sidebar/folder", {
    name,
    workspace_id: productId,
  });
  const validatedData = transformAndValidateSidebarFolder(res.data);
  return validatedData;
};
